import { IUser } from "./../entities/user/index";
import { apiService } from "../services/api-service";

interface IResponseData {
  authToken?: string;
  user?: IUser;
  error?: any;
}

class AuthRepository {
  async register(userData: {
    firstName: string;
    email: string;
    avatar: string;
  }): Promise<IResponseData> {
    try {
      const response = await apiService.post("/auth/quick-register", userData);

      const { authToken, user, error } = response as unknown as IResponseData;

      if (error) {
        return { error };
      }

      if (authToken && user) {
        localStorage.setItem("token", authToken);
        localStorage.setItem("user", JSON.stringify(user));
      }

      return { authToken, user };
    } catch (err) {
      return { error: err };
    }
  }

  getUserFromStorage = (): IUser | null => {
    try {
      const userData = localStorage.getItem("user");
      return userData ? JSON.parse(userData) : null;
    } catch (err) {
      return null;
    }
  };

  getTokenFromStorage = (): string | null => {
    return localStorage.getItem("token") || null;
  };
}

export const authRepository = new AuthRepository();
